import { post } from "../methods";
function getStripeCheckoutUrl(req, headers = {}) {
  const {
    cancelPath,
    planId,
    userReturnPath,
    userReturnPathError,
    couponId,
    locale
  } = req;
  const localeParam = typeof locale === "string" && locale !== "en" ? `locale=${locale}&` : "";
  const url = `checkout/session?${localeParam}price_id=${planId}&cancel_path=${cancelPath}${couponId && `&coupon=${couponId}`}${userReturnPath && `&user_return_path=${userReturnPath}`}${userReturnPathError && `&user_return_path_error=${userReturnPathError}`}`;
  return post({
    url,
    headers,
    baseURL: "https://billing.simplywall.st/"
  });
}
export {
  getStripeCheckoutUrl as default
};
